// React js
import React from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

// components
import { ProtectedRoute } from '@components/ProtectedRoute';

// layouts
import DashboardLayout from '@layouts/dashboard/DashboardLayout';
import NotFound from '@page/Page404';
import DashboardApp from '@page/Dashboard/index';
import authRoutes from '@page/Auth/AuthRoutes';
import OriginalData from '@page/OriginalData';
import SendDownLink from '@page/SendDownLink';
import ReturnCommand from '@page/ReturnCommand';
import Devices from '@page/Devices';
import AddDevice from '@page/Devices/Add';
import Customer from '@page/Customer';
import AddCustomer from '@page/Customer/Add';
import DeviceInformationDetail from '@page/Devices/Detail';
import { Maps } from '@page/Maps';
import ReplaceDevice from '@page/Devices/Replacement';
import DetailCustomer from '@page/Customer/Detail';
import Statistics from '@page/Statistics';
import StatisticsByMonth from '@page/StatisticsByMonth';
import Replacements from '@page/Replacements';
import AddReplacements from '@page/Replacements/Add';
import Configs from '@page/Configs';
import AddConfigs from '@page/Configs/Add';
import Warnings from '@page/Warnings';
import SendDownLinkV2 from '@page/SendDownLinkV2';
import CheckLeak from '@page/LeakDetector/Check';
import LeakDetectorStatistic from '@page/LeakDetector/Statistics';
import ManageUserOperator from '@page/AdminPage/ManageUserOperator';
import UserDetail from '@page/AdminPage/ManageUserOperator/components/Detail';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        { path: '/dashboard', element: <DashboardApp /> },
        { path: '/devices', element: <Devices /> },
        { path: '/devices/add', element: <AddDevice /> },
        { path: '/device/:id', element: <AddDevice /> },
        { path: '/device/replace/:id', element: <ReplaceDevice /> },
        { path: '/device/detail/:id', element: <DeviceInformationDetail /> },
        { path: '/device/original-data', element: <OriginalData /> },
        { path: '/device/send-downlink-command', element: <SendDownLink /> },
        { path: '/device/return-command', element: <ReturnCommand /> },
        { path: '/customers', element: <Customer /> },
        { path: '/customer/add', element: <AddCustomer /> },
        { path: '/customer/:id', element: <AddCustomer /> },
        { path: '/customer/detail/:id', element: <DetailCustomer disabled={true} /> },
        { path: '/customer/consumption-statistics', element: <Statistics /> },
        { path: '/consumption-statistics/by-month', element: <StatisticsByMonth /> },
        { path: '/customer/maps', element: <Maps /> },
        { path: '/replacements', element: <Replacements /> },
        { path: '/replacement/add', element: <AddReplacements /> },
        { path: '/replacement/update/:id', element: <AddReplacements /> },
        { path: '/replacement/detail/:id', element: <AddReplacements disabled={true} /> },
        { path: '/configs', element: <Configs /> },
        { path: '/config/add', element: <AddConfigs /> },
        { path: '/config/update/:id', element: <AddConfigs /> },
        { path: '/config/detail/:id', element: <AddConfigs disabled={true} /> },
        { path: '/warnings', element: <Warnings /> },
        { path: '/device/check-leak', element: <CheckLeak /> },
        { path: '/device/check-leak-statistics', element: <LeakDetectorStatistic /> },
        { path: '/users', element: <ManageUserOperator /> },
        {
          path: '/user/:id',
          element: <UserDetail />
        }
      ]
    },
    ...authRoutes,
    { path: '/', element: <Navigate to="/dashboard" /> },
    { path: '/device/send-downlink-command-v2', element: <SendDownLinkV2 /> },
    { path: '*', element: <NotFound /> }
  ]);
}
